import { createClient } from '@supabase/supabase-js';

// Agrega tu URL y clave pública de Supabase
const supabaseUrl = 'https://nxvdqeolibnnivnjgjwh.supabase.co';
//const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54dmRxZW9saWJubml2bmpnandoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzE4MTIwMzEsImV4cCI6MjA0NzM4ODAzMX0.euwk9O_TNAVf5xGP7FIPK00hbg-JZKsbPsFyruLwifE';
const supabaseKey2 = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im54dmRxZW9saWJubml2bmpnandoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzE4MTIwMzEsImV4cCI6MjA0NzM4ODAzMX0.euwk9O_TNAVf5xGP7FIPK00hbg-JZKsbPsFyruLwifE';

export const supabase = createClient(supabaseUrl, supabaseKey2);


